import React from "react";
import ServicesHero from "./sections/ServicesHero/ServicesHero";
import ServicesDetailed from "./sections/ServicesDetailed/ServicesDetailed";
import ServicesResults from "./sections/ServicesResults/ServicesResults";
import ServicesCTA from "./sections/ServicesCTA/ServicesCTA";
import "./Services.css";

const Services = () => {
  return (
    <div className="services-page">
      <ServicesHero />
      <ServicesDetailed />
      <ServicesResults />
      <ServicesCTA />
    </div>
  );
};

export default Services;
